import API from "../../..";
import { fullUrl } from '../../../utile/utile.api';

/* パスワード変更（ログイン中の企業が自身のパスワードを変更する） */

export type PasswordChangeRequestParam = {
  /** ○	現在のパスワード */
  current_password: string,
  /** ○	新しいパスワード */
  password: string,
  /** ○	確認用パスワード */
  password_confirmation: string,
}

const path = '/change';

const change = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    put: (param: PasswordChangeRequestParam) => API.con
      .put<PasswordChangeRequestParam, {}>({ url: full, data: param }),
  })
}

export default change;
